// Hooks / Node modules / Styles
import { Layout, Content, ContentArea } from "elseware-ui";

// Reducers / Actions

// Utils / Functions

// Components
import GenericLayout from "src/layout/standard/GenericLayout";
import CustomHeader from "src/components/base/custom-header/CustomHeader";
import CustomFooter from "src/components/base/custom-footer/CustomFooter";

// Sub-Components

// Data / Images / Icons

function DefaultLayout({ children }) {
  return (
    <GenericLayout>
      <Layout>
        {/* Header */}
        <CustomHeader />

        {/* Content */}
        <Content styles="pt-[60px]">
          <ContentArea enablePadding>{children}</ContentArea>
        </Content>

        {/* Footer */}
        <CustomFooter />
      </Layout>
    </GenericLayout>
  );
}

export default DefaultLayout;
